// extracted by mini-css-extract-plugin
export default {"vendorAndCurrency":"vendorAndCurrency--LN1uk","exchangeDisplay":"exchangeDisplay--DwkwR"};